import Element from '../ui/Element';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import ClickableMixin from './mixins/ClickableMixin';
import ContainableMixin from './mixins/ContainableMixin';
import mixin from '../privates/utils/mixin';
import StyleMixin from './mixins/styleMixins/StyleMixin';

class Form extends Element {

}

mixin(Form.prototype, HiddenCollapsedMixin.prototype);
mixin(Form.prototype, ClickableMixin.prototype);
mixin(Form.prototype, ContainableMixin.prototype);
mixin(Form.prototype, StyleMixin.prototype);

export default Form;
